package org.hs_soft.runmynesto.pages.components.dialog.dialog

import androidx.compose.runtime.*
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.*
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import org.hs_soft.runmynesto.domain.config.*
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.home.data_assistant_logs.DataAssistantLogsModel
import org.hs_soft.runmynesto.domain.model.home.home.user_profile_info.GetUserProfileData
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.virtual_card.virtual_card_config.GetVirtualCardConfig
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model.*
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomTextArea
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.home.mvi.HomeEvent
import org.hs_soft.runmynesto.pages.home.sub_page.options.mvi.OptionsEvent
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLElement
import kotlin.math.log


@Composable
fun DataAssistantAIDialog(
    windowSizeMode: WindowSizeModeEnum,
    onBackgroundClick: (String) -> Unit,
    onCancelDataAssistantButtonClick: (String) -> Unit,
    onQuestionInputChange: (String) -> Unit,
    onFavoriteMessagesChange: (String, ChatMessageHistoryModel, MutableList<String>) -> Unit,
    loading:Boolean,
    databaseLoading:Boolean,
    onGenerateAnswerClick: (String, String, ChatMessageHistoryModel, String?, String, String, String) -> Unit,
    onFavoriteMessagesButtonClick: (Boolean) -> Unit,
    userInfoVisible: Boolean,
    onInfoButtonClick: (Boolean) -> Unit,
    onMoreButtonClick: (Boolean) -> Unit,
    question: String,
    messageHistory: ChatMessageHistoryModel,
    sendIsClickable: Boolean,
    info: GetVirtualCardConfig?,
    profileInfo: GetUserProfileData?,
    speechLanguage: String?,
    getDataAssistantMessageHistory: (String) -> Unit,
    userFavoriteMessagesVisible: Boolean,
    moreMenuVisible: Boolean,
    logs: DataAssistantLogsModel,
    logLanguage: String?,
    freeCredits: Long?,
    premiumCredits: Long?,
    inputBarVisible: Boolean,
    setInputBarVisible: (Boolean) -> Unit
)
{
    val freeLow = freeCredits != null && freeCredits < 100 && freeCredits > 0
    val premiumLow = premiumCredits != null && premiumCredits < 100 && premiumCredits > 0
    val showWarning = !userFavoriteMessagesVisible && !userInfoVisible &&
            (freeLow || (premiumLow && (freeCredits == null || freeCredits <= 0)))
    val dialogHeight = if (showWarning) {
        Dimen.dataAssistantAIDialogHeight + Dimen.warningBannerHeight
    } else {
        Dimen.dataAssistantAIDialogHeight
    }

    LaunchedEffect(Unit){
        getDataAssistantMessageHistory(info!!.issuerEmail ?: "")
    }

    Box(
        modifier = Modifier
            .fillMaxHeight()
            .backgroundDialog()
            .onClick {
                onBackgroundClick(info!!.issuerEmail ?: "")
            }
    ){
        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                    onMoreButtonClick(false)
                }
                .align(Alignment.BottomEnd)
                .margin(right = Dimen.extraExtraLargePadding, bottom = Dimen.extraExtraLargePadding)
                //.padding(top = 0.px, leftRight = Dimen.mediumPadding, bottom = Dimen.mediumPadding)
                .overflow(Overflow.Hidden)
                .width(Dimen.dataAssistantAIDialogWidth)
                .height(dialogHeight)
                .backgroundColor(Theme.White.rgb)
                .zIndex(Constants.ZIndex.smallZIndex)
                .boxShadow(
                    color = Theme.Divider.rgb,
                    blurRadius = Dimen.smallBlurRadius,
                )
                .borderRadius(r= Dimen.mediumBorderRadius)
                .border(width = Dimen.smallThickness, style = LineStyle.Solid, color = Theme.Divider.rgb),
            horizontalAlignment = Alignment.CenterHorizontally
        ){
            if (showWarning) {
                CreditsWarningBanner(
                    freeCredits = freeCredits,
                    premiumCredits = premiumCredits,
                    onInfoButtonClick = onInfoButtonClick,
                    freeLow = freeLow,
                    premiumLow = premiumLow,
                    setInputBarVisible = setInputBarVisible
                )
                Box(
                    modifier = Modifier
                        .width(Dimen.dataAssistantAIDialogWidth)
                        .height(Dimen.smallThickness)
                        .backgroundColor(Theme.Divider.rgb)
                )
            }

            Header(
                info=info,
                onCancelDataAssistantButtonClick=onCancelDataAssistantButtonClick,
                onFavoriteMessagesButtonClick=onFavoriteMessagesButtonClick,
                userFavoriteMessagesVisible=userFavoriteMessagesVisible,
                userInfoVisible=userInfoVisible,
                onInfoButtonClick=onInfoButtonClick,
                showMoreMenu = moreMenuVisible,
                setShowMoreMenu = onMoreButtonClick,
                setInputBarVisible = setInputBarVisible,
                sendIsClickable = sendIsClickable,
                loading = loading
            )

            ChatMessages(
                messageHistory = messageHistory,
                databaseLoading = databaseLoading,
                info = info,
                profileInfo = profileInfo,
                userFavoriteMessagesVisible=userFavoriteMessagesVisible,
                userInfoVisible = userInfoVisible,
                onQuestionInputChange=onQuestionInputChange,
                onFavoriteMessagesChange=onFavoriteMessagesChange,
                generatingMessage =  if (logs.isGenerating == true) logs.answer else "",
                freeCredits = freeCredits,
                premiumCredits = premiumCredits,
                windowSizeMode = windowSizeMode,
                onFavoriteMessagesButtonClick = onFavoriteMessagesButtonClick,
                onInfoButtonClick = onInfoButtonClick,
                setInputBarVisible = setInputBarVisible,
                sendIsClickable = sendIsClickable,
                loading = loading
            )

            if (loading){
                LoadingComponent(loading=loading, logs=logs)
            }

            if (databaseLoading){
                LoadingDatabaseComponent(loading=databaseLoading)
            }

            Spacer()

            if (inputBarVisible) {
                GenerateAnswer(
                    onQuestionInputChange=onQuestionInputChange,
                    onGenerateAnswerClick=onGenerateAnswerClick,
                    question=question,
                    messageHistory = messageHistory,
                    sendIsClickable = sendIsClickable,
                    info = info,
                    speechLanguage = speechLanguage,
                    logLanguage = logLanguage,
                    profileInfo = profileInfo,
                    freeCredits = freeCredits,
                    premiumCredits = premiumCredits,
                    loading = loading
                )
            }
        }

    }
}

@Composable
fun CreditsWarningBanner(
    freeCredits: Long?,
    premiumCredits: Long?,
    onInfoButtonClick: (Boolean) -> Unit,
    freeLow: Boolean,
    premiumLow: Boolean,
    setInputBarVisible: (Boolean) -> Unit
) {
     Box(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(Theme.LightOrangeFocus.rgb)
                .padding(topBottom = Dimen.normalPadding, leftRight = Dimen.largePadding)
                .borderRadius(topLeft = Dimen.mediumBorderRadius, topRight = Dimen.mediumBorderRadius, bottomLeft = 0.px, bottomRight = 0.px).gap(Dimen.largePadding)
        ) {
            Row(
                verticalAlignment = Alignment.Top
            ) {
                Box(
                    modifier = Modifier
                        .align(Alignment.CenterVertically)
                        .margin(right = Dimen.largePadding)
                ) {
                    VectorIcon(
                        modifier = Modifier,
                        pathData = Res.PathIcon.warning,
                        width = Dimen.mediumIconSize,
                        height = Dimen.mediumIconSize,
                        color = Theme.LightOrange.hex
                    )
                }

                Column() {
                    if (freeLow) {
                        Row {
                            SpanText(
                                text = Strings.current().freeCredits,
                                modifier = Modifier
                                    .fontFamily(FontFamily.Jakarta)
                                    .color(Theme.LightOrange.rgb)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .fontWeight(FontWeight.SemiBold)
                            )
                            SpanText(
                                text = " ${Strings.current().creditsWarning} (${freeCredits ?: 0}).",
                                modifier = Modifier
                                    .fontFamily(FontFamily.Jakarta)
                                    .color(Theme.LightOrange.rgb)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .fontWeight(FontWeight.Normal)
                            )
                        }
                        Row {
                            SpanText(
                                text = Strings.current().premiumCredits,
                                modifier = Modifier
                                    .fontFamily(FontFamily.Jakarta)
                                    .color(Theme.LightOrange.rgb)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .fontWeight(FontWeight.SemiBold)
                            )
                            SpanText(
                                text = " (${premiumCredits ?: 0}).",
                                modifier = Modifier
                                    .fontFamily(FontFamily.Jakarta)
                                    .color(Theme.LightOrange.rgb)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .fontWeight(FontWeight.Normal)
                            )
                        }
                    } else if (premiumLow && (freeCredits == null || freeCredits <= 0)) {
                        Row {
                            SpanText(
                                text = Strings.current().premiumCredits,
                                modifier = Modifier
                                    .fontFamily(FontFamily.Jakarta)
                                    .color(Theme.LightOrange.rgb)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .fontWeight(FontWeight.SemiBold)
                            )
                            SpanText(
                                text = " ${Strings.current().creditsWarning} (${premiumCredits ?: 0}).",
                                modifier = Modifier
                                    .fontFamily(FontFamily.Jakarta)
                                    .color(Theme.LightOrange.rgb)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .fontWeight(FontWeight.Normal)
                            )
                        }
                        Row {
                            SpanText(
                                text = Strings.current().freeCredits,
                                modifier = Modifier
                                    .fontFamily(FontFamily.Jakarta)
                                    .color(Theme.LightOrange.rgb)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .fontWeight(FontWeight.SemiBold)
                            )
                            SpanText(
                                text = " (${freeCredits ?: 0}).",
                                modifier = Modifier
                                    .fontFamily(FontFamily.Jakarta)
                                    .color(Theme.LightOrange.rgb)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .fontWeight(FontWeight.Normal)
                            )
                        }
                    }
                    SpanText(
                        text = "${Strings.current().learnMore}.",
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .textDecorationLine(TextDecorationLine.Underline)
                            .fontSize(FontSizes.mediumFontSize)
                            .fontFamily(FontFamily.Jakarta)
                            .fontWeight(FontWeight.Normal)
                            .color(Theme.LightOrange.rgb)
                            .onClick {
                                onInfoButtonClick(true)
                                setInputBarVisible(false)
                            }
                    )
                }
            }
        }
}

@Composable
private fun LoadingComponent(loading: Boolean, logs: DataAssistantLogsModel) {
    var visible by remember { mutableStateOf(true) }
    var displayedMessage by remember { mutableStateOf(logs.message) }
    val fadeDurationMs = 300

    LaunchedEffect(logs.message) {
        if (logs.message != displayedMessage) {
            visible = false
            delay(fadeDurationMs.toLong())
            displayedMessage = logs.message
            visible = true
        }
    }

    if (loading) {
        SpanText(
            text = if (displayedMessage.isNullOrBlank()) Strings.current().analizeQuestionProcess else displayedMessage ?: Strings.current().analizeQuestionProcess,
            modifier = Modifier
                .display(DisplayStyle.Block)
                .fillMaxWidth()
                .textAlign(TextAlign.Center)
                .fontSize(FontSizes.mediumFontSize)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.Medium)
                .color(Theme.LightOrange.rgb)
                .opacity(if (visible) 1.0 else 0.0)
                .overflowWrap(OverflowWrap.Anywhere)
                .wordBreak(WordBreak.BreakAll)
                .whiteSpace(WhiteSpace.PreWrap)
                .styleModifier {
                    property("transition", "opacity ${fadeDurationMs}ms")
                }
        )
    }
}

@Composable
private fun LoadingDatabaseComponent(loading: Boolean) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally
        )
        {
            SpanText(
                text = Strings.current().dataAssistantDatabaseLoadingTitle,
                modifier = Modifier
                    .fontSize(FontSizes.mediumFontSize)
                    .fontFamily(FontFamily.Jakarta)
                    .fontWeight(FontWeight.Medium)
                    .color(Theme.PrimaryMain.rgb)
                    .overflowWrap(OverflowWrap.Anywhere)
                    .wordBreak(WordBreak.BreakAll)
                    .whiteSpace(WhiteSpace.PreWrap)
            )
        }
    }
}


@Composable
private fun GenerateAnswer(
    onQuestionInputChange: (String) -> Unit,
    onGenerateAnswerClick: (String, String, ChatMessageHistoryModel, String?, String, String, String) -> Unit,
    question: String,
    messageHistory: ChatMessageHistoryModel,
    sendIsClickable: Boolean,
    info: GetVirtualCardConfig?,
    speechLanguage: String?,
    logLanguage: String?,
    profileInfo: GetUserProfileData?,
    freeCredits: Long?,
    premiumCredits: Long?,
    loading: Boolean
) {
    var isListening by remember { mutableStateOf(false) }

    fun startListening() {
        setupSpeechRecognition(
            { speechText -> onQuestionInputChange(speechText) },
            speechLanguage = speechLanguage
        )
        startRecognition()
        isListening = true
    }

    fun stopListening() {
        stopRecognition()
        isListening = false
    }

    Box(
        modifier = Modifier
            .width(Dimen.dataAssistantAIDialogWidth)
            .margin(bottom=Dimen.normalPadding)
            .height(Dimen.smallThickness)
            .backgroundColor(Theme.Divider.rgb)
    )

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(leftRight = Dimen.largePadding, bottom = Dimen.largePadding),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        Box(
            modifier = Modifier
                .weight(Constants.ZIndex.smallZIndex)
        ) {
            CustomTextArea(
                value = question,
                label = Strings.current().question,
                placeholder = Strings.current().typeOrUseVoice,
                width = Dimen.largeEditTextWidth,
                height = Dimen.semiNormalTextAreaHeight,
                maxHeight = Dimen.semiNormalTextAreaHeight,
                isManualResize = false,
                onFocusOut = {

                }
            ) {
                onQuestionInputChange(it)
            }
        }

        if (question.isEmpty()) {
            Box(
                modifier = Modifier
                    .circleHoverAroundItem(
                        padding = 0.px,
                        hoveredColor = Theme.PrimaryStatesHover.rgb,
                        focusedColor = Theme.PrimaryStatesFocus.rgb,
                        onClick = { if (isListening) stopListening() else startListening() }
                    )
            ) {
                Image(
                    src = Res.PathIcon.voiceControl,
                    modifier = Modifier
                        .fillMaxSize()
                        .cursor(Cursor.Pointer)
                        .size(Dimen.largeIconSize.px)
                )
            }
        } else {
            if (isListening) {
                stopListening()
            }

            Row(
                modifier = Modifier
                    .size(Dimen.semiLargeIconSize2.px)
                    .circleHoverAroundItem(
                        padding = 0.px,
                        hoveredColor = Theme.PrimaryStatesHover.rgb,
                        focusedColor = Theme.PrimaryStatesFocus.rgb,
                        onClick = {
                            if (question.isNotEmpty() && !loading && sendIsClickable && ((freeCredits != null && freeCredits > 0) || (premiumCredits != null && premiumCredits > 0)))
                                onGenerateAnswerClick(info!!.issuerEmail ?: "", question, messageHistory, logLanguage, profileInfo?.user?.name ?: "", profileInfo?.user?.email ?: "", profileInfo?.company?.name ?: "")
                        }
                    )
            )
            {
                VectorIcon(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .margin(top = Dimen.semiSemiNormalPadding, left = Dimen.semiNormalPadding),
                    pathData = Res.PathIcon.sendQuestion,
                    width = Dimen.mediumIconSize, // normalIconSize
                    height = Dimen.mediumIconSize, // normalIconSize
                    color = if (question.isNotEmpty() && !loading && sendIsClickable && ((freeCredits != null && freeCredits > 0) || (premiumCredits != null && premiumCredits > 0))) Theme.PrimaryMain.hex
                    else Theme.Gray3E.hex
                )
            }
        }
    }
}



@Composable
fun CreditsInfo(
    freeCredits: Long?,
    premiumCredits: Long?,
    windowSizeMode: WindowSizeModeEnum,
    onFavoriteMessagesButtonClick: (Boolean) -> Unit,
    onInfoButtonClick: (Boolean) -> Unit,
    setInputBarVisible: (Boolean) -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = Dimen.normalPadding, leftRight = Dimen.largePadding)
            .gap(Dimen.normalPadding),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .align(Alignment.CenterVertically)
                .circleHoverAroundItem(
                    padding = 0.px,
                    onClick = {
                        onFavoriteMessagesButtonClick(false)
                        onInfoButtonClick(false)
                        setInputBarVisible(true)
                    }
                )
        ) {
            VectorIcon(
                modifier = Modifier
                    .cursor(Cursor.Pointer),
                pathData = Res.PathIcon.leftArrow,
                width = Dimen.semiLargeIconSize2,
                height = Dimen.semiLargeIconSize2,
                color = Theme.ActionActive.hex
            )
        }
        SpanText(
            Strings.current().info,
            modifier = Modifier
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.SemiBold)
                .fontSize(FontSizes.semiLargeFontSize)
                .color(Theme.PrimaryMain.rgb)
        )
    }

    Div(
        attrs = {
            style {
                width(100.percent);
                property("max-height", 100.percent);
                overflowY("auto")
                paddingBottom(Dimen.largePadding)
                paddingLeft(Dimen.largePadding)
                paddingRight(Dimen.largePadding)
                property("display", "flex")
                property("flex-direction", "column")
            }
        }
    )
    {
        Box(
            modifier = Modifier
                .maxWidth(Dimen.dataAssistantAIDialogWidth)
                .padding(top = Dimen.normalPadding, bottom = Dimen.largePadding, leftRight = Dimen.largePadding)
                .margin(top = Dimen.largePadding)
                .borderRadius(Dimen.semiLargeRadius)
                .alignSelf(org.jetbrains.compose.web.css.AlignSelf.FlexStart)
                .gap(Dimen.semiNormalPadding)
                .boxShadow(
                    offsetY = Dimen.smallOffsetY,
                    blurRadius = Dimen.normalBlurRadius,
                    color = Colors.Black.copyf(alpha = Dimen.semiSmallAlpha)
                )
                .backgroundColor(
                    Theme.PrimaryStatesFocus.rgb// else Theme.LightOrangeFocus.rgb
                ),
            contentAlignment = Alignment.CenterStart
        ) {
            Column {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = Dimen.smallPadding),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SpanText(
                        text = "${Strings.current().freeCredits}: ${freeCredits ?: 0}",
                        modifier = Modifier
                            .fontSize(FontSizes.semiLargeFontSize)
                            .color(Theme.PrimaryMain.rgb)
                            .fontFamily(FontFamily.Jakarta)
                            .fontWeight(FontWeight.SemiBold)
                            .overflowWrap(OverflowWrap.Anywhere)
                            .wordBreak(WordBreak.BreakAll)
                            .whiteSpace(WhiteSpace.PreWrap)
                    )
                }
                MultilineHtmlSpan(
                    text = Strings.current().freeCreditsInfo,
                    fontSize = FontSizes.semiMediumFontSize
                )
            }
        }

        Box(
            modifier = Modifier
                .maxWidth(Dimen.dataAssistantAIDialogWidth)
                .padding(top = Dimen.normalPadding, bottom = Dimen.largePadding, leftRight = Dimen.largePadding)
                .margin(top = Dimen.largePadding)
                .borderRadius(Dimen.semiLargeRadius)
                .alignSelf(org.jetbrains.compose.web.css.AlignSelf.FlexStart)
                .gap(Dimen.semiNormalPadding)
                .boxShadow(
                    offsetY = Dimen.smallOffsetY,
                    blurRadius = Dimen.normalBlurRadius,
                    color = Colors.Black.copyf(alpha = Dimen.semiSmallAlpha)
                )
                .backgroundColor(Theme.LightOrangeFocus.rgb),
            contentAlignment = Alignment.CenterStart
        ) {
            Column {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(bottom = Dimen.smallPadding),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SpanText(
                        text = "${Strings.current().premiumCredits}: ${premiumCredits ?: 0}",
                        modifier = Modifier
                            .fontSize(FontSizes.semiLargeFontSize)
                            .color(Theme.LightOrange.rgb)
                            .fontFamily(FontFamily.Jakarta)
                            .fontWeight(FontWeight.SemiBold)
                            .overflowWrap(OverflowWrap.Anywhere)
                            .wordBreak(WordBreak.BreakAll)
                            .whiteSpace(WhiteSpace.PreWrap)
                    )
                }
                MultilineHtmlSpan(
                    text = Strings.current().premiumCreditsInfo,
                    fontSize = FontSizes.semiMediumFontSize
                )

                CustomButton(
                    modifier = Modifier.margin(top = Dimen.semiNormalPadding).padding(
                        leftRight = Dimen.largePadding, topBottom = Dimen.smallPadding
                    ),
                    title = Strings.current().topUpCredits,
                    buttonType = ButtonTypes.CONTAINED,
                    windowSizeMode = windowSizeMode,
                    onButtonClick = {

                    },
                )
            }
        }

    }
}


@Composable
private fun ChatMessages(
    messageHistory: ChatMessageHistoryModel,
    databaseLoading: Boolean,
    info: GetVirtualCardConfig?,
    profileInfo: GetUserProfileData?,
    userFavoriteMessagesVisible: Boolean,
    userInfoVisible: Boolean,
    onQuestionInputChange: (String) -> Unit,
    onFavoriteMessagesChange: (String, ChatMessageHistoryModel, MutableList<String>) -> Unit,
    generatingMessage: String?,
    freeCredits: Long?,
    premiumCredits: Long?,
    windowSizeMode: WindowSizeModeEnum,
    onFavoriteMessagesButtonClick: (Boolean) -> Unit,
    onInfoButtonClick: (Boolean) -> Unit,
    setInputBarVisible: (Boolean) -> Unit,
    sendIsClickable: Boolean,
    loading: Boolean
) {
    var userFavoriteMessagesState by remember { mutableStateOf(messageHistory.favoriteMessages) }

    LaunchedEffect(messageHistory.favoriteMessages) {
        userFavoriteMessagesState = messageHistory.favoriteMessages
    }

    val expertModeStates = remember { mutableStateMapOf<Int, Boolean>() }
    val favoriteMessageHoverStates = remember { mutableStateMapOf<Int, Boolean>() }
    val favoriteMessageClickStates = remember { mutableStateMapOf<Int, Boolean>() }
    val messageHoverStates = remember { mutableStateMapOf<Int, Boolean>() }
    val favoriteButtonsHoverStates = remember { mutableStateMapOf<Int, Boolean>() }

    if (userFavoriteMessagesVisible) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = Dimen.normalPadding, leftRight = Dimen.largePadding)
                .gap(Dimen.normalPadding),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(
                modifier = Modifier
                    .align(Alignment.CenterVertically)
                    .circleHoverAroundItem(
                        padding = 0.px,
                        onClick = {
                            onFavoriteMessagesButtonClick(false)
                            onInfoButtonClick(false)
                            setInputBarVisible(true)
                        }
                    )
            ) {
                VectorIcon(
                    modifier = Modifier
                        .cursor(Cursor.Pointer),
                    pathData = Res.PathIcon.leftArrow,
                    width = Dimen.semiLargeIconSize2,
                    height = Dimen.semiLargeIconSize2,
                    color = Theme.ActionActive.hex
                )
            }
            SpanText(
                Strings.current().favorites,
                modifier = Modifier
                    .fontFamily(FontFamily.Jakarta)
                    .fontWeight(FontWeight.SemiBold)
                    .fontSize(FontSizes.semiLargeFontSize)
                    .color(Theme.PrimaryMain.rgb)
            )
        }
        Div(
            attrs = {
                style {
                    width(100.percent);
                    property("max-height", 100.percent);
                    overflowY("auto")
                    paddingBottom(Dimen.largePadding)
                    paddingLeft(Dimen.largePadding)
                    paddingRight(Dimen.largePadding)
                    property("display", "flex")
                    property("flex-direction", "column")
                }
            }
        )
        {
            userFavoriteMessagesState.forEachIndexed { idx, message ->
                val favoriteMessageHovered = favoriteMessageHoverStates.getOrPut(idx) { false }
                val favoriteMessageClicked = favoriteMessageClickStates.getOrPut(idx) { false }
                Row(
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .onMouseEnter { favoriteMessageHoverStates[idx] = true }
                        .onMouseLeave { favoriteMessageHoverStates[idx] = false }
                        .maxWidth(Dimen.dataAssistantAIDialogWidth)
                        .padding(top = Dimen.normalPadding, bottom = Dimen.largePadding, leftRight = Dimen.largePadding)
                        .margin(top = Dimen.largePadding)
                        .borderRadius(Dimen.semiLargeRadius)
                        .alignSelf(org.jetbrains.compose.web.css.AlignSelf.FlexStart)
                        .gap(Dimen.semiNormalPadding)
                        .boxShadow(
                            offsetY = Dimen.smallOffsetY,
                            blurRadius = Dimen.normalBlurRadius,
                            color = Colors.Black.copyf(alpha = Dimen.semiSmallAlpha)
                        )
                        .onClick {
                            favoriteMessageClickStates[idx] = true
                            CoroutineScope(Dispatchers.Main).launch {
                                delay(100)
                                favoriteMessageClickStates[idx] = false
                            }
                            onQuestionInputChange(message)
                            onInfoButtonClick(false)
                            onFavoriteMessagesButtonClick(false)
                            setInputBarVisible(true)
                        }
                        .backgroundColor(
                            if (favoriteMessageClicked) Theme.PrimaryStatesFocus.rgb else Theme.ActionHover.rgb
                        ),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    MultilineHtmlSpan(message)
                    Box(
                        modifier = Modifier
                            .size(Dimen.mediumIconSize.px)
                            .zIndex(Constants.ZIndex.largeZIndex)
                            .onMouseEnter { favoriteButtonsHoverStates[idx] = true }
                            .onMouseLeave { favoriteButtonsHoverStates[idx] = false }
                            .cursor(Cursor.Pointer)
                            .circleHoverAroundItem(
                                padding = 0.px,
                                onClick = {
                                    val updated = userFavoriteMessagesState.filterIndexed { i, _ -> i != idx }.toMutableList()
                                    userFavoriteMessagesState = updated
                                    onFavoriteMessagesChange(info!!.issuerEmail ?: "", messageHistory, updated)
                                }
                            )
                    ) {
                        if (favoriteMessageHovered) {
                            VectorIcon(
                                modifier = Modifier,
                                pathData = Res.PathIcon.delete,
                                width = Dimen.mediumIconSize,
                                height = Dimen.mediumIconSize,
                                color = Theme.ActionActive.hex
                            )
                        }
                    }

                }
            }
        }
    } else if (userInfoVisible) {
        CreditsInfo(
            freeCredits = freeCredits,
            premiumCredits = premiumCredits,
            windowSizeMode = windowSizeMode,
            onFavoriteMessagesButtonClick = onFavoriteMessagesButtonClick,
            onInfoButtonClick = onInfoButtonClick,
            setInputBarVisible = setInputBarVisible
        )
    } else if (messageHistory.chatMessageHistory.isEmpty() && !databaseLoading) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .display(DisplayStyle.Flex)
                .flexDirection(FlexDirection.Column)
                .alignItems(AlignItems.Center)
                .justifyContent(JustifyContent.Center)
                .padding(top = 0.px, leftRight = Dimen.largePadding)
        ) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Box(
                    modifier = Modifier
                ) {
                    Image(
                        src = Res.PathIcon.restoMateWelcome,
                        modifier = Modifier
                            .width(Dimen.dataAssistantWelcomeWidth)
                            .height(Dimen.dataAssistantWelcomeHeight)
                            .margin(bottom = Dimen.semiNormalPadding)
                    )
                }
                SpanText(
                    text = Strings.current().dataAssistantWelcomeMessage,
                    modifier = Modifier
                        .fontSize(FontSizes.mediumFontSize)
                        .color(Theme.TextDisabled.rgb)
                        .fontFamily(FontFamily.Jakarta)
                        .fontWeight(FontWeight.Medium)
                )
            }
        }
    } else if (!databaseLoading) {
        var scrollRef by remember { mutableStateOf<HTMLElement?>(null) }

        LaunchedEffect(messageHistory.chatMessageHistory.size, generatingMessage) {
            delay(30)
            scrollRef?.let {
                it.scrollTop = it.scrollHeight.toDouble()
            }
        }
        Div(
            attrs = {
                ref { refElem ->
                    scrollRef = refElem
                    onDispose { scrollRef = null }
                }
                style {
                    width(100.percent);
                    property("max-height", 100.percent);
                    overflowY("auto")
                    property("display", "flex")
                    property("flex-direction", "column")
                    paddingBottom(Dimen.largePadding)
                    paddingLeft(Dimen.largePadding)
                    paddingRight(Dimen.largePadding)
                }
            }
        )
        {
            messageHistory.chatMessageHistory.forEachIndexed { idx, message ->
                var messageVisible by remember { mutableStateOf(false) }
                val messageHovered = messageHoverStates.getOrPut(idx) { false }
                var favoriteClicked by remember { mutableStateOf(userFavoriteMessagesState.contains(message.content.text)) }
                val favoriteHovered = favoriteButtonsHoverStates.getOrPut(idx) { false }
                LaunchedEffect(Unit) {
                    messageVisible = true
                }
                LaunchedEffect(messageHistory.favoriteMessages) {
                    favoriteClicked = messageHistory.favoriteMessages.contains(message.content.text)
                }
                Box(
                    modifier = Modifier
                        .styleModifier {
                            property("opacity", if (messageVisible) "1" else "0")
                            property("transition", "opacity 0.6s")
                        }
                        .onMouseEnter { messageHoverStates[idx] = true }
                        .onMouseLeave { messageHoverStates[idx] = false }
                        .maxWidth(Dimen.dataAssistantAIDialogWidth)
                        .padding(top = Dimen.normalPadding, bottom = Dimen.largePadding, leftRight = Dimen.largePadding)
                        .margin(top = Dimen.largePadding)
                        .borderRadius(Dimen.semiLargeRadius)
                        .alignSelf(org.jetbrains.compose.web.css.AlignSelf.FlexStart)
                        .gap(Dimen.semiNormalPadding)
                        .boxShadow(
                            offsetY = Dimen.smallOffsetY,
                            blurRadius = Dimen.normalBlurRadius,
                            color = Colors.Black.copyf(alpha = Dimen.semiSmallAlpha)
                        )
                        .backgroundColor(
                            if (message.role == RoleMessageEnum.USER.role) Theme.PrimaryStatesFocus.rgb else Theme.LightOrangeFocus.rgb
                        ),
                    contentAlignment = Alignment.CenterStart
                ) {
                    Column {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .margin(bottom = Dimen.smallPadding),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            SpanText(
                                text = if (message.role == RoleMessageEnum.USER.role) profileInfo?.user?.name ?: RoleMessageEnum.USER.role.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() } else ApiUtils.DATA_ASSISTANT.name,
                                modifier = Modifier
                                    .fontSize(FontSizes.mediumFontSize)
                                    .color(
                                        if (message.role == RoleMessageEnum.USER.role) Theme.PrimaryMain.rgb else Theme.LightOrange.rgb
                                    )
                                    .fontFamily(FontFamily.Jakarta)
                                    .fontWeight(FontWeight.SemiBold)
                                    .overflowWrap(OverflowWrap.Anywhere)
                                    .wordBreak(WordBreak.BreakAll)
                                    .whiteSpace(WhiteSpace.PreWrap)
                            )
                            if (message.role == RoleMessageEnum.USER.role) {
                                Box(
                                    modifier = Modifier
                                        .size(Dimen.mediumIconSize.px)
                                        .display(DisplayStyle.Flex)
                                        .alignItems(AlignItems.Center)
                                        .justifyContent(JustifyContent.Center)
                                        .onMouseEnter { favoriteButtonsHoverStates[idx] = true }
                                        .onMouseLeave { favoriteButtonsHoverStates[idx] = false }
                                        .cursor(Cursor.Pointer)
                                        .circleHoverAroundItem(
                                            padding = 0.px,
                                            onClick = {
                                                if (sendIsClickable && !loading) {
                                                    val updated = if (!favoriteClicked) {
                                                        userFavoriteMessagesState + message.content.text
                                                    } else {
                                                        userFavoriteMessagesState.filter { it != message.content.text }
                                                    }
                                                    userFavoriteMessagesState = updated.toMutableList()
                                                    onFavoriteMessagesChange(
                                                        info!!.issuerEmail ?: "",
                                                        messageHistory,
                                                        userFavoriteMessagesState
                                                    )
                                                }
                                            }
                                        )
                                ) {
                                    if (messageHovered) {
                                        VectorIcon(
                                            modifier = Modifier,
                                            pathData = if (favoriteClicked) Res.PathIcon.restoMateFavoriteFilled else Res.PathIcon.restoMateFavoriteEmpty,
                                            width = Dimen.smallIconSize,
                                            height = Dimen.smallIconSize,
                                            color = if (favoriteHovered) Theme.PrimaryMain.hex else Theme.PrimaryStatesOutlinedBorder.hex
                                        )
                                    }
                                }
                            }
                        }
                        MultilineHtmlSpan(message.content.text)
                        if ((info!!.issuerEmail
                                ?: "") == ApiUtils.DATA_ASSISTANT.testEmail && message.role == RoleMessageEnum.ASSISTANT.role && message.content.expertMode != null
                        ) {
                            val expertModeExpanded = expertModeStates.getOrPut(idx) { false }
                            SpanText(
                                text = Strings.current().expertMode,
                                modifier = Modifier
                                    .color(Theme.LightOrange.rgb)
                                    .cursor(Cursor.Pointer)
                                    .fontFamily(FontFamily.Jakarta)
                                    .fontSize(FontSizes.mediumFontSize)
                                    .textDecorationLine(TextDecorationLine.Underline)
                                    .onClick { expertModeStates[idx] = !expertModeExpanded }
                            )
                            if (expertModeExpanded) {
                                ExpertModePanel(
                                    expertMode = message.content.expertMode
                                )
                            }
                        }
                    }
                }
                message.content.files.forEach { file ->
                    ChatFileItem(
                        modifier = Modifier.styleModifier {
                            property("opacity", if (messageVisible) "1" else "0")
                            property("transition", "opacity 0.6s")
                        },
                        fileName = file.fileFormat,
                        fileIconPath = Res.PathIcon.restoMateFile,
                        expiry = "${Strings.current().availableToDownloadUntil}: ${file.expiry}",
                        downloadUrl = file.path
                    )
                }
            }
            if (!generatingMessage.isNullOrBlank()) {
                Box(
                    modifier = Modifier
//                        .styleModifier {
//                            property("opacity", if (messageVisible) "1" else "0")
//                            property("transition", "opacity 0.6s")
//                        }
//                        .onMouseEnter { messageHoverStates[idx] = true }
//                        .onMouseLeave { messageHoverStates[idx] = false }
                        .maxWidth(Dimen.dataAssistantAIDialogWidth)
                        .padding(top = Dimen.normalPadding, bottom = Dimen.largePadding, leftRight = Dimen.largePadding)
                        .margin(top = Dimen.largePadding)
                        .borderRadius(Dimen.semiLargeRadius)
                        .alignSelf(org.jetbrains.compose.web.css.AlignSelf.FlexStart)
                        .gap(Dimen.semiNormalPadding)
                        .boxShadow(
                            offsetY = Dimen.smallOffsetY,
                            blurRadius = Dimen.normalBlurRadius,
                            color = Colors.Black.copyf(alpha = Dimen.semiSmallAlpha)
                        )
                        .backgroundColor(Theme.LightOrangeFocus.rgb),
                    contentAlignment = Alignment.CenterStart
                ) {
                    Column {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .margin(bottom = Dimen.smallPadding),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            SpanText(
                                text = ApiUtils.DATA_ASSISTANT.name,
                                modifier = Modifier
                                    .fontSize(FontSizes.mediumFontSize)
                                    .color(Theme.LightOrange.rgb)
                                    .fontFamily(FontFamily.Jakarta)
                                    .fontWeight(FontWeight.SemiBold)
                                    .overflowWrap(OverflowWrap.Anywhere)
                                    .wordBreak(WordBreak.BreakAll)
                                    .whiteSpace(WhiteSpace.PreWrap)
                            )
                        }
                        DataAssistantStreamingMessage(answer = generatingMessage)
                    }
                }
            }
        }
    }
}


@Composable
fun DataAssistantStreamingMessage(answer: String) {
    var caretVisible by remember { mutableStateOf(true) }

    LaunchedEffect(answer) {
        while (caretVisible) {
            caretVisible = !caretVisible
            delay(250)
        }
    }
    MultilineHtmlSpan("$answer▌")
}

@Composable
fun ExpertModePanel(expertMode: ChatExpertModeModel) {
    val totalSteps = expertMode.steps.size
    val totalTime = expertMode.totalTimeSpentSec

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .borderRadius(Dimen.mediumBorderRadius)
            .backgroundColor(Theme.LightOrangeFocus.rgb)
            .padding(Dimen.semiLargePadding)
    ) {
        SpanText(
            text = "${Strings.current().total} ${Strings.current().steps}: $totalSteps, ${Strings.current().total} ${Strings.current().time}: ${totalTime} ${Strings.current().sec}",
            modifier = Modifier
                .fontFamily(FontFamily.Jakarta)
                .fontSize(FontSizes.mediumFontSize)
                .color(Theme.LightOrange.rgb)
                .fontWeight(FontWeight.SemiBold)
                .margin(bottom = Dimen.mediumPadding)
        )
        expertMode.steps.forEach { step ->
            StepDetailsCard(step)
        }
    }
}


@Composable
private fun StepDetailsCard(step: ChatExpertModeStepModel) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Theme.White.rgb)
            .borderRadius(Dimen.lowBorderRadius)
            .padding(Dimen.mediumPadding)
            .margin(bottom = Dimen.normalPadding)
            .boxShadow(offsetY = Dimen.smallOffsetY, blurRadius = Dimen.normalBlurRadius, color = Colors.Black.copyf(alpha = Dimen.semiSmallAlpha))
    ) {
        SpanText(
            text = "${Strings.current().step} ${step.number}: ${step.name}",
            modifier = Modifier
                .fontSize(FontSizes.mediumFontSize)
                .fontFamily(FontFamily.Jakarta)
                .fontWeight(FontWeight.SemiBold)
                .color(Theme.LightOrange.rgb)
                .margin(bottom = Dimen.semiNormalPadding)
        )
        when (val details = step.details) {
            is StepDetailsModel.Request -> {
                KeyValueLine(Strings.current().model, details.model)
                KeyValueLine(Strings.current().status, details.status)
                KeyValueLine("${Strings.current().time} ${Strings.current().spent}", "${details.time_spent_sec} ${Strings.current().sec}")
            }
            is StepDetailsModel.FunctionCalling -> {
                KeyValueLine(Strings.current().name, details.name)
                SpanText(
                    text = "${Strings.current().arguments}:",
                    modifier = Modifier
                        .fontFamily(FontFamily.Jakarta)
                        .color(Theme.LightOrange.rgb)
                        .fontSize(FontSizes.mediumFontSize)
                        .fontWeight(FontWeight.Medium)
                )
                Column(modifier = Modifier.margin(left = Dimen.mediumPadding)) {
                    details.arguments.forEach { (k, v) ->
                        KeyValueLine(k, v.toString())
                    }
                }
                KeyValueLine(Strings.current().weight, details.weight.toString())
                KeyValueLine(Strings.current().lambda_seconds, details.lambda_seconds.toString())
                KeyValueLine(Strings.current().data_size_kbytes, details.data_size_bytes.toString())
                KeyValueLine(Strings.current().file_count, details.file_count.toString())
                KeyValueLine(Strings.current().is_premium, details.is_premium.toString())
                KeyValueLine(Strings.current().status, details.status)
                KeyValueLine("${Strings.current().time} ${Strings.current().spent}", "${details.time_spent_sec} ${Strings.current().sec}")
            }
            is StepDetailsModel.Generate -> {
                KeyValueLine("${Strings.current().total} ${Strings.current().tokens} ${Strings.current().spent}", details.total_tokens_spent.toString())
                KeyValueLine(Strings.current().status, details.status)
                KeyValueLine("${Strings.current().time} ${Strings.current().spent}", "${details.time_spent_sec} ${Strings.current().sec}")
            }
        }
    }
}

@Composable
private fun KeyValueLine(key: String, value: String) {
    Row(verticalAlignment = Alignment.Top) {
        SpanText(
            text = "$key:",
            modifier = Modifier
                .fontFamily(FontFamily.Jakarta)
                .color(Theme.LightOrange.rgb)
                .fontSize(FontSizes.mediumFontSize)
                .fontWeight(FontWeight.Medium)
        )
        MultilineSpan(" $value")
    }
}

@Composable
fun ChatFileItem(
    modifier: Modifier,
    fileName: String,
    fileIconPath: String,
    expiry: String,
    downloadUrl: String? = null
) {
    fun isExpired(expiry: String): Boolean {
        val parts = expiry.split(", ")
        if (parts.size != 2) return false

        val timePart = parts[1]
        val timeFields = timePart.split(":")
        if (timeFields.size != 2) return false

        val hour = timeFields[0].toIntOrNull() ?: return false
        val minute = timeFields[1].toIntOrNull() ?: return false

        val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())

        return now.hour >= hour && now.minute >= minute
    }

    val isExpired = remember(expiry) { isExpired(expiry) }

    val content: @Composable () -> Unit = {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundColor(Theme.LightOrangeFocus.rgb)
                .borderRadius(Dimen.semiLargeRadius)
                .padding(topBottom = Dimen.normalPadding, leftRight = Dimen.largePadding)
                .cursor(if (!isExpired && downloadUrl != null) Cursor.Pointer else Cursor.Default)
        ) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(Dimen.semiMediumPadding),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    modifier = Modifier
                        .size(Dimen.mediumIconSize.px)
                        .display(DisplayStyle.Flex)
                        .alignItems(AlignItems.Center)
                        .justifyContent(JustifyContent.Center)
                ) {
                    VectorIcon(
                        modifier = Modifier,
                        pathData = fileIconPath,
                        width = Dimen.smallIconSize,
                        height = Dimen.normalIconSize,
                        color = Theme.LightOrange.hex
                    )
                }
                SpanText(
                    text = fileName,
                    modifier = Modifier
                        .fontFamily(FontFamily.Jakarta)
                        .fontSize(FontSizes.mediumFontSize)
                        .fontWeight(FontWeight.Normal)
                        .color(Theme.TextPrimary.rgb)
                        .overflowWrap(OverflowWrap.BreakWord)
                )
            }
            SpanText(
                text = if (isExpired) Strings.current().downloadExpired else expiry,
                modifier = Modifier
                    .margin(top = Dimen.extraSmallPadding)
                    .fontFamily(FontFamily.Jakarta)
                    .fontWeight(FontWeight.Normal)
                    .fontSize(FontSizes.normalFontSize)
                    .color(Theme.TextSecondary.rgb)
                    .overflowWrap(OverflowWrap.BreakWord)
                    .whiteSpace(WhiteSpace.PreWrap)
            )
        }
    }

    if (!isExpired && downloadUrl != null) {
        Link(
            path = downloadUrl,
            modifier = modifier
                .textDecorationLine(TextDecorationLine.None)
                .margin(top = Dimen.largePadding)
                .gap(Dimen.smallPadding),
            content = content
        )
    } else {
        Box(
            modifier = modifier
                .margin(top = Dimen.largePadding)
                .gap(Dimen.smallPadding)
                .fillMaxWidth()
                .opacity(0.5)) {
            content()
        }
    }
}


@Composable
private fun MultilineHtmlSpan(text: String, fontSize: CSSSizeValue<CSSUnit. px> = FontSizes.mediumFontSize) {
    var elementRef by remember { mutableStateOf<HTMLElement?>(null) }

    Div({
        ref { element ->
            elementRef = element
            onDispose { elementRef = null }
        }
        style {
            fontSize(fontSize)
            fontFamily(FontFamily.Jakarta)
            color(Colors.Black)
            property("overflow-wrap", "anywhere")
            property("word-break", "break-word")
            property("white-space", "pre-wrap")
            property("overflow-x", "hidden")
        }
    }) { Text("") }

    LaunchedEffect(text, elementRef) {
        elementRef?.innerHTML = text
    }
}

@Composable
private fun MultilineSpan(text: String) {
    SpanText(
        text = text,
        modifier = Modifier
            .fontSize(FontSizes.mediumFontSize)
            .overflowWrap(OverflowWrap.Anywhere)
            .wordBreak(WordBreak.BreakAll)
            .overflow(Overflow.Hidden)
            .whiteSpace(WhiteSpace.PreWrap)
    )
}

@Composable
private fun Header(
    info: GetVirtualCardConfig?,
    onCancelDataAssistantButtonClick: (String) -> Unit,
    onFavoriteMessagesButtonClick: (Boolean) -> Unit,
    onInfoButtonClick: (Boolean) -> Unit,
    userFavoriteMessagesVisible: Boolean,
    userInfoVisible: Boolean,
    showMoreMenu: Boolean,
    setShowMoreMenu: (Boolean) -> Unit,
    setInputBarVisible: (Boolean) -> Unit,
    sendIsClickable: Boolean,
    loading: Boolean
) {
    Row(
        modifier = Modifier
            .padding(
                top = Dimen.semiNormalPadding,
                bottom = Dimen.semiNormalPadding,
                left = Dimen.normalPadding,
                right = Dimen.largePadding
            )
            .fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically
        ) {
            Image(
                src = Res.PathIcon.restoMateAnimated,
                modifier = Modifier
                    .size(Dimen.dataAssistantButtonSize.px)
                    .margin(right=Dimen.normalPadding)
            )
            Column {
                SpanText(
                    text = ApiUtils.DATA_ASSISTANT.name,
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .fontSize(FontSizes.semiLargeFontSize)
                        .fontFamily(FontFamily.Jakarta)
                        .fontWeight(FontWeight.SemiBold)
                        .color(Theme.TextPrimary.rgb)
                )
                SpanText(
                    text = Strings.current().restoMateDescription,
                    modifier = Modifier
                        .cursor(Cursor.Pointer)
                        .fontSize(FontSizes.semiMediumFontSize)
                        .fontFamily(FontFamily.Jakarta)
                        .fontWeight(FontWeight.Medium)
                        .color(Theme.TextPrimary.rgb)
                )
            }
        }

        Row(verticalAlignment = Alignment.CenterVertically) {
            Box(
                modifier = Modifier
                    .position(Position.Relative)
            ) {
                Box(
                    modifier = Modifier
                        .circleHoverAroundItem(
                            padding = 0.px,
                            onClick = {
                                if (sendIsClickable && !loading) {
                                    setShowMoreMenu(!showMoreMenu) }
                                }
                        )
                ) {
                    VectorIcon(
                        modifier = Modifier.cursor(Cursor.Pointer),
                        pathData = Res.PathIcon.dots3,
                        width = Dimen.semiLargeIconSize2,
                        height = Dimen.semiLargeIconSize2,
                        color = Theme.ActionActive.hex
                    )
                }
                if (showMoreMenu) {
                    MoreMenuPopup(
                        modifier = Modifier
                            .position(Position.Absolute)
                            .top(Dimen.dataAssistantButtonSize.px - Dimen.largePadding)
                            .left(-250.px),
                        onFavoritesClick = {
                            setShowMoreMenu(false)
                            onFavoriteMessagesButtonClick(!userFavoriteMessagesVisible)
                            onInfoButtonClick(false)
                            setInputBarVisible(userFavoriteMessagesVisible)
                        },
                        onInfoClick = {
                            setShowMoreMenu(false)
                            onInfoButtonClick(!userInfoVisible)
                            onFavoriteMessagesButtonClick(false)
                            setInputBarVisible(userInfoVisible)
                        }
                    )
                }
            }

            Box(
                modifier = Modifier
                    .circleHoverAroundItem(
                        padding = 0.px,
                        onClick = {
                            onCancelDataAssistantButtonClick(info!!.issuerEmail ?: "")
                            setShowMoreMenu(false)
                            onFavoriteMessagesButtonClick(false)
                            onInfoButtonClick(false)
                            setInputBarVisible(true)
                        }
                    )
            ) {
                VectorIcon(
                    modifier = Modifier.cursor(Cursor.Pointer),
                    pathData = Res.PathIcon.restoMateClose,
                    width = Dimen.semiLargeIconSize2,
                    height = Dimen.semiLargeIconSize2,
                    color = Theme.ActionActive.hex
                )
            }
        }
    }

    Box(
        modifier = Modifier
            .width(Dimen.dataAssistantAIDialogWidth)
            .margin(top=Dimen.normalPadding, bottom = 1.px)
            .height(Dimen.smallThickness)
            .backgroundColor(Theme.Divider.rgb)
    )
}

@Composable
fun MoreMenuPopup(
    modifier: Modifier = Modifier,
    onFavoritesClick: () -> Unit,
    onInfoClick: () -> Unit
) {
    Column(
        modifier = modifier
            .width(Dimen.menuItemRowWidth)
            .backgroundColor(Theme.White.rgb)
            .borderRadius(6.px)
            .boxShadow(blurRadius = 12.px, color = Colors.Black.copyf(alpha = 0.06f))
            .zIndex(998)
            .padding(Dimen.smallPadding)
            .onClick { it.stopPropagation() }
    ) {
        MenuEntry(
            icon = Res.PathIcon.restoMateFavoritesList,
            text = Strings.current().favorites,
            onClick = onFavoritesClick
        )
        MenuEntry(
            icon = Res.PathIcon.info,
            text = Strings.current().info,
            onClick = onInfoClick
        )
    }
}

@Composable
fun MenuEntry(
    icon: String,
    text: String,
    onClick: () -> Unit
) {
    var hovered by remember { mutableStateOf(false) }
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(Dimen.menuItemRowHeight)
            .cursor(Cursor.Pointer)
            .padding(topBottom = Dimen.normalPadding, leftRight = Dimen.largePadding)
            .backgroundColor(if (hovered) Theme.ActionHover.rgb else Theme.White.rgb)
            .borderRadius(Dimen.semiLargeRadius)
            .onMouseEnter { hovered = true }
            .onMouseLeave { hovered = false }
            .onClick { onClick() },
        verticalAlignment = Alignment.CenterVertically
    ) {
        VectorIcon(
            pathData = icon,
            width = Dimen.mediumIconSize,
            height = Dimen.mediumIconSize,
            color = if (hovered) Theme.PrimaryMain.hex else Theme.ActionActive.hex,
            modifier = Modifier.margin(right = Dimen.largePadding)
        )
        SpanText(
            text,
            modifier = Modifier
                .fontFamily(FontFamily.Jakarta)
                .color(if (hovered) Theme.PrimaryMain.rgb else Theme.TextPrimary.rgb)
                .fontSize(FontSizes.semiLargeFontSize)
        )
    }
}

fun setupSpeechRecognition(
    onResultCallback: (String) -> Unit,
    speechLanguage: String?
) {
    js(
        """
        if (!('webkitSpeechRecognition' in window)) {
            console.error("Speech recognition not supported in this browser.")
            return
        }

        var recognition = new webkitSpeechRecognition()
        recognition.continuous = false;
        recognition.interimResults = false;
        recognition.lang = speechLanguage;

        recognition.onresult = function(event) {
            var lastResult = event.results[event.resultIndex];
            if (lastResult.isFinal) {
                var speechResult = lastResult[0].transcript.trim();
                onResultCallback(speechResult);
            }
        };

        recognition.onerror = function(event) {
            console.error("Speech recognition error", event.error);
        };

        recognition.onend = function() {
            console.log("Speech recognition service disconnected");
        };

        window.recognition = recognition;
        """
    )
}

fun startRecognition() {
    js("window.recognition.start();")
}

fun stopRecognition() {
    js("window.recognition.stop();")
}
